<template>
  <v-container fluid>
    <h2 class="mb-1">{{ $t('myCommunities') }}</h2>
    <ClubModule/>
    <v-divider class="my-5"/>
    <h2 class="mb-1">{{ $t('sharedJournal') }}</h2>
    <SharingModule/>
  </v-container>
</template>

<script>
import SharingModule from "@/views/Community/SharingModule";
import ClubModule from "@/views/Community/ClubModule";

export default {
  name: "CommunityIndex",
  components: {ClubModule, SharingModule},
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>


